module.exports = __webpack_public_path__ + "img/tab-placeholder-poster-horizontal.5f50c7da.svg";